import { useNavigate } from "react-router-dom";

import { RunStatusIcon } from "@/components/RunStatusIcon";
import { SeverityBadge } from "@/components/SeverityBadge";
import { StatusBadge } from "@/components/StatusBadge";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import type { IncidentSummary } from "@/api/types";
import { relativeAge, truncate } from "@/lib/utils";

export function IncidentTable({ items }: { items: IncidentSummary[] }) {
  const navigate = useNavigate();

  if (items.length === 0) {
    return (
      <div className="rounded-md border bg-card p-8 text-center text-sm text-muted-foreground">
        No hay incidentes que coincidan con los filtros.
      </div>
    );
  }

  return (
    <div className="rounded-md border bg-card">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-20">Severidad</TableHead>
            <TableHead className="w-24">Status</TableHead>
            <TableHead className="w-40">Host(s)</TableHead>
            <TableHead>Resumen</TableHead>
            <TableHead className="w-20 text-right">Eventos</TableHead>
            <TableHead className="w-24">Edad</TableHead>
            <TableHead className="w-20 text-center">Playbook</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {items.map((it) => (
            <TableRow
              key={it.incident_id}
              className="cursor-pointer"
              onClick={() => navigate(`/incidents/${it.incident_id}`)}
            >
              <TableCell>
                <SeverityBadge value={it.priority} />
              </TableCell>
              <TableCell>
                <StatusBadge value={it.status} />
              </TableCell>
              <TableCell className="font-mono text-xs">
                {renderHosts(it.affected_hosts)}
              </TableCell>
              <TableCell title={it.summary}>{truncate(it.summary, 80)}</TableCell>
              <TableCell className="text-right tabular-nums">{it.event_count}</TableCell>
              <TableCell className="tabular-nums text-muted-foreground">
                {relativeAge(it.created_at)}
              </TableCell>
              <TableCell className="text-center">
                <div className="flex justify-center">
                  <RunStatusIcon status={it.last_playbook_run_status} />
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}

function renderHosts(hosts: string[]): string {
  if (hosts.length === 0) return "—";
  if (hosts.length === 1) return hosts[0];
  return `${hosts[0]} +${hosts.length - 1}`;
}
